<question [title]="title" [description]="description" [valueOnly]="valueOnly">
  <ion-list *ngIf="!valueOnly" class="question-yes-no-list">
    <ion-radio-group [(ngModel)]="value" (ionChange)="valueChanged()">
      <ion-row>
        <ion-col>
          <ion-item (click)="value = 'true'; valueChanged()">
            <ion-radio slot="start" value="true" mode="md" id="yes" [attr.aria-label]="'COMMON.YES' | translate"></ion-radio>
            <ion-label>
              <div translate>COMMON.YES</div>
            </ion-label>
          </ion-item>
        </ion-col>
        <ion-col>
          <ion-item (click)="value = 'false'; valueChanged()">
            <ion-radio slot="start" value="false" mode="md" id="no" [attr.aria-label]="'COMMON.NO' | translate"></ion-radio>
            <ion-label>
              <div translate>COMMON.NO</div>
            </ion-label>
          </ion-item>
        </ion-col>  
      </ion-row>  
    </ion-radio-group>
  </ion-list>
  <div *ngIf="valueOnly">
    <ion-button *ngIf="value === 'true'" expand="full" fill="clear" color="dark"><div translate>COMMON.YES</div></ion-button>
    <ion-button *ngIf="value === 'false'" expand="full" fill="clear" color="dark"><div translate>COMMON.NO</div></ion-button>
  </div>
</question>
